export interface OklchColor {
  l: number // lightness (0-1)
  c: number // chroma (0+)
  h: number // hue (0-360)
  alpha?: number // opacity (0-1), default is 1
}

export const DEFAULT_SOURCE_COLOR: OklchColor = {
  l: 0.5,
  c: 0.2,
  h: 300,
}
